// Chart.js 4.4.0
import palette from 'theme/palette';
import { useTranslation } from 'react-i18next';


export const useChartOptions  = () => {

  const { t } = useTranslation();

  return {

    plugins: {
      title: {
        display: true,
        // text: 'VGI Capacitiy[kW] up/down',
        text: t("vgi_capacity_updown") + ' [kW]',
        position: 'bottom',
      },

      legend: {
        // display: true,
        position: 'top',
        align: 'end',
      },

    },
    stacked: false,
    responsive: true,
    maintainAspectRatio: false,
    // aspectRatio: 1,
    animation: false,
    cornerRadius: 8,


    scales: {
      x: {
        ticks: {
          fontColor: palette.text.secondary,
          autoSkip: true,
          fontSize: 12,
          maxTicksLimit: 20 //tick간격
        },
        gridLines: {
          display: false,
          drawBorder: false
        }
      }
      ,

      y:
      {
        // display:true,
        beginAtZero: true,
        title: {
          display: true,
          // text: "Capacities [kW]", // Change the label here
          text: t("capacities") + ' [kW]',
          font: {
            // size: 12,
            // weight: "bold",
          },
          padding: 0,
        },
        grid: {
          borderDash: [2],
          borderDashOffset: [2],
          color: palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: palette.divider,
        },
      },
    },
  };
};
